import { css } from 'emotion';


export default {
  formContainer: css`
    max-width: 500px;
    margin: auto;
  `,
};
